import { z } from "zod";
import { MetaSchema } from "./shared";

export const ConnectWalletBodySchema = z.object({
  cipher: z.string(),
  iv: z.string(),
  tag: z.string(),
});

export const ReferralCodeSchema = z.object({
  id: z.string().uuid(),
  code: z.string(),
  is_expired: z.boolean(),
  used_count: z.number(),
  max_usage: z.number(),
});

export const TeamSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  status: z.string(),

  contractAddressDepositETH: z.string(),
  contractAddressWithdrawETH: z.string(),

  contractAddressDepositBSC: z.string(),
  contractAddressWithdrawBSC: z.string(),

  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const TokenSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string(),
});

export const WalletSchema = z.object({
  gGold: z.string().optional(),
  address: z.string(),
  amount: z.string().nullable().optional(),
  id: z.string().uuid(),
  uuid: z.string().uuid().optional(),
});

export const InvestmentPlanSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),

  star: z.number(),
  weight: z.number(),

  minReturn: z.number(),
  maxReturn: z.number(),

  status: z.string(),

  isVisible: z.boolean(),
  isPurchasable: z.boolean(),

  planType: z.string(),

  canBuildNetwork: z.boolean(),
  hasROI: z.boolean(),
  hasPrincipalReturn: z.boolean(),

  includesInMaxLeadCalculation: z.boolean(),
  isWithdrawableInvestment: z.boolean(),

  FixedProfit: z.number().nullable().optional(),

  principalReturnRateMonthly: z.number().nullable(),
  principalReturnStartAt: z.string().datetime().nullable(),

  randomProfit: z.boolean(),

  description: z.string().nullable(),

  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const ConnectWalletDataSchema = z.object({
  id: z.string().uuid(),
  uuid: z.string().optional(),

  isActivePlan: z.boolean(),

  role: z.string(),
  avatar: z.string().optional(),
  rank: z.string().optional(),

  activatedPlanAt: z.string().datetime().nullable().optional(),
  createdAt: z.string().datetime(),

  referralCodes: z.array(ReferralCodeSchema),

  team: TeamSchema.optional(),
  isActiveInArbitrage: z.boolean().optional(),
  isActiveInMaxLeads: z.boolean().optional(),
  isActiveInMaxleads: z.boolean().optional(),
  token: TokenSchema,

  wallet: WalletSchema,

  user_hash: z.string(),

  biggestUserPurchasedPack: InvestmentPlanSchema.nullable()
    .optional()
    .or(z.string().optional().nullable()),

  lastIdentityVerifiedAt: z.string().nullable(),
});

const ConnectWalletResponse = z.object({
  data: ConnectWalletDataSchema,
  meta: MetaSchema.default,
});

export type ConnectWalletBodyType = z.infer<typeof ConnectWalletBodySchema>;

export type ConnectWalletResponseType = z.infer<typeof ConnectWalletResponse>;

export default ConnectWalletResponse;
